import { render, staticRenderFns } from "./NewFormWrapper.vue?vue&type=template&id=5fed17cf&scoped=true"
import script from "./NewFormWrapper.vue?vue&type=script&lang=ts"
export * from "./NewFormWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed17cf",
  null
  
)

export default component.exports